window.getSite = function() {
  let site = 'TEST'; // 默认测试环境
  if (window.env === 'prd' && window.Shopify && window.Shopify.shop) {
    const shop = window.Shopify.shop;
    let siteMap = {
      "segway-navimow-us.myshopify.com": 'US',
      "segway-navimow-store-eu.myshopify.com": 'EU',
    };
    site = siteMap[shop];
  }
  return site;
}
